import DOMPurify from 'dompurify';

const formatLineBreak = (text: string) => {
  const splitTexts = text.split(/\\n/);

  return splitTexts
    .map((line) => {
      if (line.trim() === '') {
        return '';
      }
      return `<div>${DOMPurify.sanitize(line)}</div>`;
    })
    .join('');
};

export { formatLineBreak };
